import { Box, Typography } from "@mui/material";

const DEFAULT_HEADER_BG = "rgba(34, 35, 37, 0.04)";
const DEFAULT_BORDER = "1px solid rgba(0,0,0,0.08)";

export const TableShell = ({
  children,
  sx,
  border = DEFAULT_BORDER,
  radius = 1.25,
  overflow = "hidden",
}) => (
  <Box
    sx={{
      border,
      borderRadius: radius,
      overflow,
      width: "100%",
      ...sx,
    }}
  >
    {children}
  </Box>
);

export const TableHeaderRow = ({
  children,
  sx,
  component = "div",
  gridTemplateColumns,
  gap = 1,
  px = 1,
  py = 0.5,
  backgroundColor = DEFAULT_HEADER_BG,
}) => (
  <Box
    component={component}
    sx={{
      display: gridTemplateColumns ? "grid" : undefined,
      gridTemplateColumns,
      gap,
      px,
      py,
      backgroundColor,
      ...sx,
    }}
  >
    {children}
  </Box>
);

export const TableCell = ({
  children,
  label,
  component = "div",
  align = "left",
  variant = "caption",
  fontWeight = 700,
  color,
  sx,
  typographySx,
  ...rest
}) => (
  <Box component={component} sx={{ textAlign: align, ...sx }} {...rest}>
    {children ??
      (label !== undefined ? (
        <Typography
          variant={variant}
          fontWeight={fontWeight}
          color={color}
          sx={typographySx}
        >
          {label}
        </Typography>
      ) : null)}
  </Box>
);
